import { AnimatePresence, motion } from "framer-motion";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { Button, Form, Input, Modal } from "rsuite";

const SuccessfullRegistration = () => {
  return (
    <div style={{ textAlign: "center" }}>
      <h4 style={{ color: "#1579be" }}>
        🎉 Thanks for submitting your details!
      </h4>
      <p>You can now watch the recording below</p>
      <div style={{ position: "relative", paddingTop: "56.25%", height: 0 }}>
        <iframe
          src="https://www.youtube.com/embed/nbW1Z9OtGL4"
          title="How Foundries Are Growing Faster By Fixing Credit Risks and Working Capital Gap"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            borderRadius: "8px",
          }}
        ></iframe>
      </div>
    </div>
  );
};

const WebinarModal = ({ isModalOpen, handleCloseModal }) => {
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmittedSuccessfully, setIsSubmittedSuccessfully] = useState(false);

  const [formValue, setFormValue] = useState({
    name: "",
    email: "",
    phone: "",
    designation: "",
    company: "",
  });

  const validateForm = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^\d{10}$/;

    if (!formValue.name.trim()) newErrors.name = "Name is required";
    if (!emailRegex.test(formValue.email))
      newErrors.email = "Invalid email address";
    if (!phoneRegex.test(formValue.phone))
      newErrors.phone = "Invalid phone number (10 digits required)";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    setIsSubmitting(true);
    try {
      const promise = fetch(
        `${process.env.REACT_APP_GSCRIPT_URL}?function=updateWebinarData`,
        {
          method: "POST",
          mode: "no-cors",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: formValue.name,
            email: formValue.email,
            contactNumber: formValue.phone,
            designation: formValue.designation,
            company: formValue.company,
          }),
        }
      );

      toast.promise(promise, {
        pending: "Submitting...",
        success: "Registration successful!",
        error: "Registration failed!",
      });

      await promise;
      setIsSubmittedSuccessfully(true);
    } catch (error) {
      console.log(error);
      setIsSubmittedSuccessfully(false);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AnimatePresence>
      {isModalOpen && (
        <Modal open={isModalOpen} onClose={handleCloseModal} size="md">
          {!isSubmittedSuccessfully && (
            <Modal.Header>
              <Modal.Title style={{ color: "#1579be", fontWeight: 700 }}>
                Webinar Registration
              </Modal.Title>
            </Modal.Header>
          )}
          <Modal.Body>
            {isSubmittedSuccessfully ? (
              <SuccessfullRegistration />
            ) : (
              <Form fluid>
                <Form.Group>
                  <Form.ControlLabel>Full Name *</Form.ControlLabel>
                  <Input
                    name="name"
                    value={formValue.name}
                    onChange={(value) =>
                      setFormValue({ ...formValue, name: value })
                    }
                  />
                  {errors.name && (
                    <Form.HelpText style={{ color: "red" }}>
                      {errors.name}
                    </Form.HelpText>
                  )}
                </Form.Group>

                <Form.Group>
                  <Form.ControlLabel>Email *</Form.ControlLabel>
                  <Input
                    name="email"
                    type="email"
                    value={formValue.email}
                    onChange={(value) =>
                      setFormValue({ ...formValue, email: value })
                    }
                  />
                  {errors.email && (
                    <Form.HelpText style={{ color: "red" }}>
                      {errors.email}
                    </Form.HelpText>
                  )}
                </Form.Group>

                <Form.Group>
                  <Form.ControlLabel>Phone Number *</Form.ControlLabel>
                  <Input
                    name="phone"
                    type="tel"
                    value={formValue.phone}
                    onChange={(value) =>
                      setFormValue({ ...formValue, phone: value })
                    }
                  />
                  {errors.phone && (
                    <Form.HelpText style={{ color: "red" }}>
                      {errors.phone}
                    </Form.HelpText>
                  )}
                </Form.Group>

                <Form.Group>
                  <Form.ControlLabel>Designation</Form.ControlLabel>
                  <Input
                    name="designation"
                    value={formValue.designation}
                    onChange={(value) =>
                      setFormValue({ ...formValue, designation: value })
                    }
                  />
                  {errors.designation && (
                    <Form.HelpText style={{ color: "red" }}>
                      {errors.designation}
                    </Form.HelpText>
                  )}
                </Form.Group>

                <Form.Group>
                  <Form.ControlLabel>Company</Form.ControlLabel>
                  <Input
                    name="company"
                    value={formValue.company}
                    onChange={(value) =>
                      setFormValue({ ...formValue, company: value })
                    }
                  />
                  {errors.company && (
                    <Form.HelpText style={{ color: "red" }}>
                      {errors.company}
                    </Form.HelpText>
                  )}
                </Form.Group>

                <motion.div whileHover={{ scale: 1.01 }}>
                  <Button
                    appearance="primary"
                    style={{
                      background:
                        "linear-gradient(90deg, #1579be 0%, rgba(21, 121, 190, 0.6) 100%)",
                      marginTop: "20px",
                      width: "100%",
                    }}
                    onClick={handleSubmit}
                    loading={isSubmitting}
                  >
                    Submit Registration
                  </Button>
                </motion.div>
              </Form>
            )}
          </Modal.Body>
        </Modal>
      )}
    </AnimatePresence>
  );
};

export default WebinarModal;
